import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownTimerProps = {
  heading: string;
  note?: string;
};
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex min-w-[86px] flex-col items-center rounded-2xl border border-line bg-ink px-4 py-4 sm:min-w-[112px]" data-id="element-50" data-mp="1t9sa845qh3l3">
      <span className="text-4xl font-extrabold tabular-nums leading-none text-gold sm:text-5xl" data-id="element-51" data-mp="1kax3mqys1rh9">
        {value}
      </span>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-[0.2em] text-neutral-500" data-id="element-52" data-mp="1fbkg04030gdm">
        {label}
      </span>
    </div>;
}
export function CountdownTimer({
  heading,
  note
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="rounded-3xl border border-ember/30 bg-raised p-6 text-center sm:p-8" data-id="element-53" data-mp="34qi7uyw3cn33">
      <p className="inline-flex items-center gap-2 text-sm font-extrabold uppercase tracking-[0.16em] text-ember" data-id="element-54" data-mp="2zrnqm1drv6l3">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="1c05h7s22ybpw" />
        {heading}
      </p>
      <div className="mt-5 flex items-center justify-center gap-3 sm:gap-4" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-56" data-mp="1gzrrbsmm3buh">
        <TimeBlock value={hours} label="hs" data-id="element-57" data-mp="170skmflepqa4" />
        <span className="text-2xl font-extrabold text-neutral-700 sm:text-4xl" data-id="element-58" data-mp="173ogzzhlw6wg">
          :
        </span>
        <TimeBlock value={minutes} label="min" data-id="element-59" data-mp="1ut9b9ej7mql1" />
        <span className="text-2xl font-extrabold text-neutral-700 sm:text-4xl" data-id="element-60" data-mp="1zqj310u2nec1">
          :
        </span>
        <TimeBlock value={seconds} label="seg" data-id="element-61" data-mp="1l0btjam1l5nh" />
      </div>
      {note ? <p className="mt-5 text-sm font-semibold text-neutral-400" data-id="element-62" data-mp="1pzy1p5n0jvpf">{note}</p> : null}
    </div>;
}